window.InifECShared.factory("ActivityService", ['$q', '$http', function($q, $http) {

    	var factory = this;

        // ------------------------------
        // Email 認證
        // ------------------------------
        var addActivityLog = function(email, name, mobilephone, postal, address, company, invoice) {

            var defer = $q.defer();

            $http({
                url: SECURE_INIFEC_URL + "/ActivityAction.do",
                method: "POST",
                params: {
                    email: email,
                    membername: name,
                    mobilephone: mobilephone,
                    postal: postal,
                    address: address,
                    company: company,
                    invoice: invoice,
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    defer.reject(data.error);
                } else {
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : ActivityService.addActivityLog request error.");
                console.error("status : " + status);
            });

            return defer.promise;

        }

        /** 設定密碼（當密碼為空的時候 */
        factory.addActivityLog = addActivityLog;

        return factory;
    }
]);
